import { apiUrl } from '../config';
import Axios from 'axios';

export default async (routerName, slug, token = '') => {
  console.log('wkwkwk', routerName);
  if (['news'].indexOf(routerName) > -1) {
    try {
      const response = await Axios.get(`${apiUrl}/post/by_url/${slug}`, {
        headers: {
          'Content-Type': 'application/json;text/plain',
          'x-access-token': token
        }
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching data:', error);
      throw error;
    }
  } else if (routerName === 'home') {
    try {
      const params = {
        page: 1,
        limit: 10,
        state_id: 3,
        schedule: 0,
        category: 'berita-utama'
      };
      const route = `/post/get_by_category`;
      const response = await Axios.get(`${apiUrl}${route}`, {
        headers: {
          'Content-Type': 'application/json;text/plain',
          'x-access-token': token
        },
        params: params
      });
      let datasBeritaUtama = [];
      if (response.data?.data?.length > 0) {
        datasBeritaUtama = response.data.data.map((dt, index) => ({
          src: dt.post.mediaable ? dt.post.mediaable.media.url : '/assets/',
          tag: dt.post.tagables ? (dt.post.tagables[0] ? dt.post.tagables[0].tag.slug : 'ivoox') : 'ivoox',
          url: dt.post.url,
          altText: index + 1,
          caption: dt.post.description,
          header: dt.post.title
        }));
      }

      return { datasBeritaUtama };
    } catch (error) {
      console.error('Error fetching home data:', error);
      throw error;
    }
  } else {
    return null;
  }
};
